import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Admin.css";
import bgImage from "../assets/images/government_of_maharashtra.png";

export default function AdminLogin() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!username || !password) {
      setError("⚠️ कृपया Admin ID आणि Password भरा");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        "http://localhost/belpimpalgaon/api/admin_login.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: username.trim(),
            password: password,
          }),
        }
      );

      const data = await response.json();

      if (data.status === "success") {
        localStorage.setItem("adminLogin", "true");
        localStorage.setItem("adminUsername", username);
        navigate("/admin/dashboard");
      } else {
        setError("❌ चुकीचा Admin ID किंवा Password");
      }
    } catch (err) {
      console.error(err);
      setError("🚫 Server Error. कृपया नंतर प्रयत्न करा");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="admin-bg"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="admin-overlay"></div>

      <div className="admin-login-card">
        <h2>महाराष्ट्र शासन</h2>
        <p>ग्रामपंचायत बेलपिंपळगाव</p>

        {error && <div className="error">{error}</div>}

        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Admin ID"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />

          <button type="submit" disabled={loading}>
            {loading ? "Logging in..." : "LOGIN"}
          </button>
        </form>
      </div>
    </div>
  );
}
